import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, XIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { CHECKOUT_URL, PRICE, ANCHOR_PRICE } from '../lib/config';
const rows: {
  without: string;
  with: string;
}[] = [{
  without: 'Improvise every wedding and hope for the best',
  with: 'Run a proven system, minute by minute'
}, {
  without: 'Undercharge, overwork, burn out',
  with: 'Price like a pro, deliver like a luxury brand'
}, {
  without: 'Start from zero with every client',
  with: 'Open the volume. Follow the system. Done.'
}];
export function Close() {
  return <section className="w-full bg-ink py-20 sm:py-28" data-id="element-45" data-mp="178qri6ibzf4n">
      <div className="mx-auto max-w-4xl px-5 text-center" data-id="element-46" data-mp="17abjpph6alzc">
        <h2 className="font-serif text-3xl leading-snug sm:text-5xl sm:leading-tight text-ivory" data-id="element-47" data-mp="12a72fx8fxn82">
          Stop winging the most important day of someone&rsquo;s life.
        </h2>
        <div className="rule-gold mx-auto mt-8 w-32" aria-hidden="true" data-id="element-48" data-mp="3vff01b517m4k" />
        <p className="mx-auto mt-8 max-w-2xl text-base sm:text-lg leading-relaxed text-ivory/70" data-id="element-49" data-mp="3vdbzhx696all">
          Join the planners who run every wedding with a system — calm on the day, premium
          on the invoice, booked through referrals.
        </p>
        <p className="mt-8 text-[11px] uppercase tracking-[0.24em] text-gold" data-id="element-50" data-mp="3qfiwfd08xwpj">
          Scripts · Budgets · Design · Vendors · The big day · Profit — all solved
        </p>

        <div className="mt-14 overflow-hidden border border-gold/30 text-left" data-id="element-51" data-mp="mzbr7226nren">
          <div className="grid grid-cols-1 sm:grid-cols-2" data-id="element-52" data-mp="mx94aqwbuee5">
            <div className="border-b border-gold/25 px-6 py-4 text-[11px] uppercase tracking-[0.2em] text-ivory/50 sm:border-r" data-id="element-53" data-mp="81je0gk3zf3m">
              Without the OS
            </div>
            <div className="hidden border-b border-gold/25 px-6 py-4 text-[11px] uppercase tracking-[0.2em] text-gold sm:block" data-id="element-54" data-mp="2ssae1qvjl3rr">
              With the OS
            </div>
          </div>
          {rows.map((row, index) => <div key={row.with} className={`grid grid-cols-1 sm:grid-cols-2 ${index > 0 ? 'border-t border-gold/20' : ''}`} data-id="element-55" data-mp="148ebdu30c16w" data-mpi={index}>
              <p className="flex items-start gap-3 px-6 py-5 text-[15px] text-ivory/55 sm:border-r sm:border-gold/20" data-id="element-56" data-mp="uhjocnhxsxke">
                <XIcon className="mt-1 h-4 w-4 shrink-0 text-ivory/35" aria-hidden="true" data-id="element-57" data-mp="phxcahduhnd6" />
                {row.without}
              </p>
              <p className="flex items-start gap-3 px-6 py-5 text-[15px] text-ivory" data-id="element-58" data-mp="gitsfb6ut3xm">
                <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-59" data-mp="bk0clc43h0ua" />
                {row.with}
              </p>
            </div>)}
        </div>

        <p className="mt-16 text-[11px] uppercase tracking-[0.3em] text-gold" data-id="element-60" data-mp="6nibcm7z3kmp">
          Launch price ends in
        </p>
        <div className="mt-7" data-id="element-61" data-mp="20zg99s0u0u3a">
          <Countdown tone="dark" data-id="element-62" data-mp="21086f7a2uzvo" />
        </div>

        <p className="mt-10 font-serif text-xl text-ivory" data-id="element-63" data-mp="20xdnjk6ppn4d">
          The Wedding Pro OS™ — 6 Volumes + 5 Bonuses
        </p>
        <p className="mt-3 flex items-end justify-center gap-3" data-id="element-64" data-mp="2dhaivkolbcgs">
          <s className="font-serif text-2xl text-ivory/40" data-id="element-65" data-mp="2dffxk59epic6">{ANCHOR_PRICE}</s>
          <span className="font-serif text-5xl leading-none text-gold" data-id="element-66" data-mp="2i90vxyewwebw">{PRICE}</span>
        </p>

        <div className="mt-9" data-id="element-67" data-mp="2n72jowna91tp">
          <CtaButton href={CHECKOUT_URL} variant="gold" data-id="element-68" data-mp="2n9gdz3a52a07">
            Yes, I want the Wedding Pro OS
          </CtaButton>
        </div>

        <ul className="mt-7 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[11px] uppercase tracking-[0.14em] text-ivory/50" data-id="element-69" data-mp="1ui51etj2n50y">
          <li className="inline-flex items-center gap-2" data-id="element-70" data-mp="1zk44e2awfzxd">
            <LockIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-71" data-mp="24i5lwisofr6q" />
            100% secure checkout
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-72" data-mp="3awod13gz4mts">
            <ZapIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-73" data-mp="3fvrjmsclr13v" />
            Instant access
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-74" data-mp="3dinpkvzrh7kz">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-75" data-mp="39g0w6qnfzelo" />
            7-day guarantee
          </li>
        </ul>
      </div>
    </section>;
}